import _ from '@lodash';
import React, { useState, useEffect } from 'react';
import { TableCell, Tooltip, IconButton } from '@material-ui/core';
import PlayArrow from '@material-ui/icons/PlayArrow';

import StreamingDialog from './StreamingDialog';
import StreamingPopup from './StreamingPopup';

function StreamingStartButton(props) {
	const [openDialog, setOpenDialog] = useState(false);

	const handleOpenDialog = () => {
		setOpenDialog(true);
	};

	return (
		<TableCell className="text-center" padding="none">
			<Tooltip title="Start Stream">
				<span>
					<IconButton onClick={handleOpenDialog}>
						<PlayArrow fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>

			{openDialog && (
				<StreamingPopup
					startStreaming
					item={props.item}
					onClose={() => {
						setOpenDialog(false);
					}}
				/>
			)}
		</TableCell>
	);
}

export default StreamingStartButton;
